import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FloatingModal from 'components/consumer/FloatingModal';
import Link from 'components/consumer/Link';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const ChatUnavailableModal = t0 => {
  const $ = _c(4);
  const {
    isOpen: t1,
    onClose
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link to="/contact-us/" className="text-brand underline hover:text-brand-darker hover:outline-none focus:text-brand-darker focus:outline-none">here</Link>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isOpen || $[2] !== onClose) {
    t3 = <FloatingModal isOpen={isOpen} onClose={onClose} title="We're currently offline">You’ve reached us outside our normal business hours. Leave us a message{" "}{t2}{" "}and we’ll get back to you as soon as possible.</FloatingModal>;
    $[1] = isOpen;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
ChatUnavailableModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};
export default withBrowserOnly(ChatUnavailableModal);